// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"Spinner_submitBtn__2r-BP","mymove":"Spinner_mymove__G8Fd_"};